import {styled, Tabs} from "@mui/material"

const SecondaryToolbarTabs = styled(Tabs)(({theme}) => ({
	height: "40px",
	cursor: "default",
	paddingBottom: "0",
	minHeight: "32px",
	alignItems: "end",
	flex: "1 1 0",
	"& .MuiTabs-indicator": {
		height: "32px",
		boxSizing: "border-box",
		borderTopRightRadius: "4px",
		borderTopLeftRadius: "4px",
		backgroundColor: theme.palette.primary.transparency30,
	},
	"& .MuiTabs-scrollButtons": {
		width: "20px"
	},
	"& .MuiTabs-flexContainer": {
		height: "40px",
		display: "flex",
		alignItems: "end",
	}
}))

export default SecondaryToolbarTabs